module.exports = __webpack_public_path__ + "img/logo.4e30e065.png";